import { objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React from 'react';

var _excluded = ["_as", "enableCaption"];
var PliableImage = function PliableImage(_ref) {
  var _as = _ref._as,
    _ref$enableCaption = _ref.enableCaption,
    enableCaption = _ref$enableCaption === void 0 ? false : _ref$enableCaption,
    props = _objectWithoutProperties(_ref, _excluded);
  var Component = _as !== null && _as !== void 0 ? _as : 'img';
  var figureStyle = enableCaption ? 'inline-block size-full object-cover pb-[29px]' : 'inline-block size-full object-cover';
  return /*#__PURE__*/React.createElement("figure", {
    className: figureStyle
  }, /*#__PURE__*/React.createElement(Component, props), enableCaption && props.caption && /*#__PURE__*/React.createElement("figcaption", {
    className: "flex flex-col self-stretch pt-2 font-sans text-p-14 font-light leading-6 text-[#757575]"
  }, props.caption));
};

export { PliableImage };
//# sourceMappingURL=pliable-image.esm.js.map
